import { Row } from "@tanstack/react-table";

import { Button } from "@/components/ui/button/button";
// import { TODO } from "./schema";
import { useTodoStatusViewModal } from "./comps/todo-status-view-modal/use-todo-status-view-modal";
// import { useTakeActionModal } from "../take-action-modal/use-action-modal";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const originData = row.original as {
    id: string;
    title: string;
    deadline: string;
    description: string;
    files: string[];
    recipients: {
      _id: string;
      name: string;
    }[];
  };

  const { onOpenChange, setTodo } = useTodoStatusViewModal();

  // const { onOpenChange, setLeadId } = useTakeActionModal();

  return (
    <>
      <Button
        size="sm"
        variant="default"
        onClick={() => {
          setTodo(originData);
          onOpenChange(true);
        }}
      >
        Progress
      </Button>
    </>
  );
}
